export default "__VITE_ASSET__Dhm9fHmr__"